// extracted by mini-css-extract-plugin
module.exports = {"playIcon":"style_playIcon__kEswH","pauseIcon":"style_pauseIcon__kexC7"};